var _defs, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPas3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Object",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1122 1122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #323a89;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 46.81px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #30378b;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 356.93,
    y: 226.22,
    width: 486.48,
    height: 67.91
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 356.93,
    y: 384.2,
    width: 486.48,
    height: 67.91
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158,
    y: 34,
    width: 789.86,
    height: 1059,
    rx: 3.83,
    ry: 3.83
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 181.4,
    y: 34,
    width: 87.76,
    height: 1059
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPas3Icon);
export default __webpack_public_path__ + "static/media/pas3Icon.2585c05bf792db986515a9f3f5b4c883.svg";
export { ForwardRef as ReactComponent };